import React from 'react';
import Typed from 'react-typed';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import TheAccordion from '../accordion/TheAccordion';
import accordionUnits from '../../data/about/accordionUnits.json';

const Mission = ({
    mainTitle,
    typedTitle,
    Paragraphe,
    Paragraphe2,
    directlink,
    positionAccord,
}) => {
    const accordionUnit = accordionUnits[positionAccord];
    const indexAccordionUnit = accordionUnit.cases;
    return (
        <div className="rn-company-mission-are rn-section-gap">
            <div className="container">
                <div className="row row--30">
                    <div className="col-lg-6">
                        <div className="mission-title">
                            <h2 className="title">
                                {mainTitle}
                                <br />{' '}
                                <Typed
                                    className="theme-gradient"
                                    strings={[`${typedTitle}`]}
                                    typeSpeed={80}
                                    backSpeed={5}
                                    backDelay={900}
                                    loop
                                />
                            </h2>
                            <p>{Paragraphe}</p>

                            <p>{Paragraphe2}</p>

                            <div className="read-more-btn mt--50">
                                <Link
                                    className="!flex items-center btn-default btn-icon"
                                    target="_blank"
                                    to={{ pathname: `${directlink}` }}
                                    style={{ maxWidth: 'fit-content' }}
                                >
                                    More{' '}
                                    <i className="icon">
                                        <FiArrowRight />
                                    </i>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mt_md--30 mt_sm--30">
                        <TheAccordion
                            customStyle=""
                            indexAccordionUnit={indexAccordionUnit}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Mission;
